export default "__VITE_ASSET__DvFisfYn__"